import { defineComponent, PropType, ref, getCurrentInstance, watch } from 'vue'
import {
  Input,
  Textarea,
  Select,
  SelectOption,
  TreeSelect,
  DatePicker,
  TimePicker,
  RangePicker,
  Cascader,
  AutoComplete
} from 'ant-design-vue'
import { FormListItem } from '@xinghai/site-common'

export default defineComponent({
  name: 'JtFormItem',
  props: {
    item: { type: Object as PropType<Partial<FormListItem>>, default: {} as Partial<FormListItem> },
    searchParam: { type: Object, default: {} as Record<string, any> }
  },
  setup(props, { attrs, slots }) {
    const instance = getCurrentInstance()
    const $lang = instance?.proxy?.$lang
    const placeholder = $lang?.(props.item.placeholder || props.item.label)
    const change = (e: any) => {}
    const text = ref(props.searchParam[props.item.prop!])
    console.log(text.value, 'props========')

    const rangePickerChange = (e: any, val: any) => {
      if (props.item.realField) {
        props.item.realField.forEach((_, i) => {
          props.searchParam![_] = val[i]
        })
      }
    }
    return () => {
      const componentsMap = {
        text: <Input v-model={text.value} {...props.item} placeholder={placeholder}></Input>,
        textarea: <Textarea v-model={text.value} {...attrs} placeholder={placeholder} />,
        select: (
          <Select
            v-model={text.value}
            v-slots={{ default: slots.default }}
            {...props.item}
            placeholder={placeholder}></Select>
        ),
        date: <DatePicker v-model={text.value} {...props.item}></DatePicker>,
        cascader: <Cascader v-model={text.value} {...props.item}></Cascader>,
        datetimerange: (
          <RangePicker v-model={text.value} {...props.item} onChange={(e, v) => rangePickerChange(e, v)}></RangePicker>
        )
      }
      return componentsMap[props.item.searchType || 'text']
    }
  }
})
